import { render, staticRenderFns } from "./pricetotal.vue?vue&type=template&id=0e09714c&"
import script from "./pricetotal.vue?vue&type=script&lang=js&"
export * from "./pricetotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e09714c')) {
      api.createRecord('0e09714c', component.options)
    } else {
      api.reload('0e09714c', component.options)
    }
    module.hot.accept("./pricetotal.vue?vue&type=template&id=0e09714c&", function () {
      api.rerender('0e09714c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2y5ZoDM6J7kvH/JS/comp/pricetotal.vue"
export default component.exports